import * as React from "react";
import Svg, { Rect, G, Path, Defs, ClipPath } from "react-native-svg";
const SVGComponent = (props) => (
  <Svg
    width={42}
    height={42}
    viewBox="0 0 42 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <Rect width={42} height={42} rx={4.2} fill={props?.bgColor ?? "#F3F5FC"} />
    <G clipPath="url(#clip0_857_7020)">
      <Path
        opacity={0.2}
        d="M11.8125 26.0529C11.8125 26.4358 11.9646 26.8031 12.2354 27.0738C12.5061 27.3446 12.8733 27.4967 13.2563 27.4967H14.7C15.0829 27.4967 15.4501 27.3446 15.7209 27.0738C15.9916 26.8031 16.1438 26.4358 16.1438 26.0529V22.4436C16.1438 22.0607 15.9916 21.6934 15.7209 21.4227C15.4501 21.1519 15.0829 20.9998 14.7 20.9998H11.8125V26.0529Z"
        fill={props?.color??"#2D57D9"}
      />
      <Path
        opacity={0.2}
        d="M26.2501 20.9998C25.8672 20.9998 25.5 21.1519 25.2293 21.4227C24.9585 21.6934 24.8064 22.0607 24.8064 22.4436V26.0529C24.8064 26.4358 24.9585 26.8031 25.2293 27.0738C25.5 27.3446 25.8672 27.4967 26.2501 27.4967H29.1376V20.9998H26.2501Z"
        fill={props?.color??"#2D57D9"}
      />
      <Path
        d="M29.1376 27.4967V28.2186C29.1376 28.9844 28.8334 29.7188 28.2919 30.2603C27.7504 30.8019 27.016 31.1061 26.2501 31.1061H21.197"
        stroke={props?.color??"#2D57D9"}
        strokeWidth={1.44375}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M29.1375 20.9998H26.25C25.8671 20.9998 25.4999 21.152 25.2291 21.4227C24.9584 21.6935 24.8063 22.0607 24.8063 22.4436V26.053C24.8063 26.4359 24.9584 26.8031 25.2291 27.0739C25.4999 27.3446 25.8671 27.4967 26.25 27.4967H29.1375V20.9998ZM29.1375 20.9998C29.1375 19.8623 28.9134 18.7358 28.4781 17.6848C28.0428 16.6339 27.4047 15.6789 26.6003 14.8745C25.7959 14.0701 24.841 13.4321 23.79 12.9967C22.739 12.5614 21.6126 12.3373 20.475 12.3373C19.3374 12.3373 18.211 12.5614 17.16 12.9967C16.109 13.4321 15.1541 14.0701 14.3497 14.8745C13.5453 15.6789 12.9072 16.6339 12.4719 17.6848C12.0366 18.7358 11.8125 19.8623 11.8125 20.9998M11.8125 20.9998V26.053C11.8125 26.4359 11.9646 26.8031 12.2354 27.0739C12.5061 27.3446 12.8733 27.4967 13.2563 27.4967H14.7C15.0829 27.4967 15.4501 27.3446 15.7209 27.0739C15.9916 26.8031 16.1438 26.4359 16.1438 26.053V22.4436C16.1438 22.0607 15.9916 21.6935 15.7209 21.4227C15.4501 21.152 15.0829 20.9998 14.7 20.9998H11.8125Z"
        stroke={props?.color??"#2D57D9"}
        strokeWidth={1.44375}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </G>
    <Defs>
      <ClipPath id="clip0_857_7020">
        <Rect
          width={23.1}
          height={23.1}
          fill="white"
          transform="translate(8.92505 9.45001)"
        />
      </ClipPath>
    </Defs>
  </Svg>
);
export default SVGComponent;
